import React, { useEffect, useState, useRef } from "react";
import deleteIcon from "../../../assets/images/delete-icon.svg";
import userIcon from "../../../assets/images/user.svg";
import {
  fetchSilentChat,
  fetchMoreMessages,
  fetchContacts,
  changeMessageReadStatus,
  fetchTags,
  fetchMessages,
  setChatPhone,
  fetchChat,
  setChatMessage,
  sendMessage,
  fetchSilentMessage,
  onChangeNotes,
  updateNotesMessage,
  fetchCustomMessages,
  fetchMessagesLoading,
  deleteMessageChat,
  triggerChatPush,
  unreadChat,
  fetchUnReadCountData,
  fetchPreferences,
  fetchChatLoading,
} from "../../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment-timezone";
import sliderCloseIcon from "../../../assets/images/slider-close-icon.svg";
import deletePopupIcon from "../../../assets/images/delete-popup-icon.svg";
import { Input, Button } from "reactstrap";
import NewMessageModal from "../../../components/Messages/NewMessageModal";
import CreateContactSlider from "../../../components/Contacts/CreateContactSlider";
import Avatar from "react-avatar";
import $ from "jquery";
import { encodePhoneNumber } from "../../../helpers/Utils";
import ScrollBar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import useAutosizeTextArea from "../../../helpers/useAutosizeTextArea";
import { Box, Image } from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  updateConversationAiStatus,
  fetchConversationAiStatus,
} from "../../../redux/action";
import { Switch } from "@chakra-ui/react";
function Messages() {
  const contacts = useSelector((state) => state.contacts);
  const hiddenFileInput = React.useRef(null);
  const textAreaRef = React.useRef(null);
  const authUser = useSelector((state) => state.authUser);
  const preferences = useSelector((state) => state.preferences);
  const messages = useSelector((state) => state.messages);
  const customMessages = useSelector((state) => state.customMessages);
  const tags = useSelector((state) => state.tags);
  const dispatch = useDispatch();
  const [filter, setFilter] = useState("All");
  const messagesEndRef = useRef(null);
  const [active, setActive] = useState(null);
  const [newMessage, setNewMessage] = useState("");
  const [query, setQuery] = useState("");
  const [selectedChats, setSelectedChats] = useState([]);
  const [selectedTag, setSelectedTag] = useState({ tag: "Tags" });
  const [isVisible, setIsVisible] = useState(false);
  const [messageType, setMessageType] = useState("individual");
  const [isSelectEnable, setIsSelectEnable] = useState(false);
  const windowSize = useRef([window.innerWidth, window.innerHeight]);
  const [photo, setPhoto] = useState(false);
  const [localPhoto, setLocalPhoto] = useState(false);
  const [shouldFetchMore, setShouldFetchMore] = useState(false);
  const [showChatDownArrow, setShowChatDownArrow] = useState(false);
  const abortController = new AbortController();
  const userSelectedFont = useSelector((state) => state.settings.fontsize);

  useAutosizeTextArea(textAreaRef.current, newMessage);

  const toggleCheckbox = (e, msg) => {
    if (e.target.checked) {
      setSelectedChats([...selectedChats, msg]);
    } else {
      var updated = selectedChats.filter((chat) => chat.id !== msg.id);
      setSelectedChats([...updated]);
    }
  };

  const getConversationVisibility = (item) => {
    const { unread_count_data, response_count_data } = messages;
    let currentCount = unread_count_data.filter(
      (val) => val.phone_no == item.phone_no
    );
    let currentResponse = response_count_data.filter(
      (val) => val.phone_no == item.phone_no
    );

    // let { filter } = this.state
    if (filter === "All") {
      return true;
    } else if (
      filter === "Unread" &&
      currentCount.length &&
      currentCount[0].count != 0
    ) {
      return true;
    } else if (
      filter === "1+ response" &&
      currentResponse.length &&
      currentResponse[0].count >= 1
    ) {
      return true;
    } else if (
      filter === "3+ response" &&
      currentResponse.length &&
      currentResponse[0].count >= 3
    ) {
      return true;
    } else if (
      filter === "5+ response" &&
      currentResponse.length &&
      currentResponse[0].count >= 5
    ) {
      return true;
    } else if (
      filter === "10+ response" &&
      currentResponse.length &&
      currentResponse[0].count >= 10
    ) {
      return true;
    }
    return false;
  };

  const handleMessageModal = (type) => {
    setMessageType(type);
    setIsVisible((old) => !old);
  };
  const bulkDelete = () => {
    for (let i = 0; i < selectedChats.length; i++) {
      let currentPhone = selectedChats[i].sender_phone;
      let phone = messages.chat_phone_no;
      if (currentPhone) {
        dispatch(fetchMessagesLoading());
        dispatch(deleteMessageChat(currentPhone));
        if (currentPhone == phone) {
          dispatch(setChatPhone(false));
        }
        dispatch(triggerChatPush());
      }
    }
    fetchMessagesData();
  };

  const fetchMessagesData = () => {
    console.log("called....");
    dispatch(fetchMessages());
    dispatch(
      setChatPhone(messages.length > 0 && messages.data[0].sender_phone)
    );
    dispatch(fetchChat());
  };

  const getCustomMessages = () => {
    dispatch(fetchCustomMessages());
  };

  const handleActiveChat = (message) => {
    setActive({ id: message.id, read_status: message.read_status });
    dispatch(setChatPhone(message.sender_phone));
    dispatch(changeMessageReadStatus(message.id));
    console.log("Updating read status...");

    dispatch(fetchChat());
  };

  const handleInputClick = () => {
    //alert(active.id)
    //if(messages?.unread_count_data.some(item=>item.phone_no==messages.chat_phone_no)){
    dispatch(
      changeMessageReadStatus(
        active?.id == undefined || active == null
          ? messages?.data[0]?.id
          : active?.id
      )
    );
    console.log("Here I am on changing read status" + active?.id);
    //}
  };

  const handleSendMessage = () => {
    dispatch(sendMessage(photo));
    setNewMessage("");
    setPhoto(false);
    setLocalPhoto(false);
    //dispatch(fetchChat())
    //console.log(active)
  };

  const handleInitialReadStatus = (message) => {
    // console.log(message)
    //if(messages?.unread_count_data.some(item=>item.phone_no==messages.chat_phone_no)){
    console.log("Updating Initial Read Status " + message?.id);
    dispatch(changeMessageReadStatus(message?.id));
    //}
  };

  const handleUnread = () => {
    if (messages.chat_phone_no) {
      dispatch(unreadChat(messages.chat_phone_no));
      dispatch(triggerChatPush());
      dispatch(fetchUnReadCountData());
    }
  };

  const handleDelete = async () => {
    let currentPhone =
      messages.chat_data.length > 0 && messages.chat_data[0].sender_phone;
    let phone = messages.chat_phone_no;
    if (currentPhone) {
      dispatch(fetchMessagesLoading());
      dispatch(deleteMessageChat(currentPhone));
      if (currentPhone == phone) {
        dispatch(setChatPhone(false));
      }
      dispatch(triggerChatPush());
    }
    fetchMessagesData();
  };

  const handleQuerySubmit = (e) => {
    if (e.key === "Enter") {
      dispatch(
        fetchMessages(
          query,
          1,
          selectedTag.tag === "Tags" ? false : selectedTag
        )
      );
    }
  };

  const getTags = () => {
    dispatch(fetchTags());
  };

  const handleToggleTag = (tag) => {
    setSelectedTag(tag);
    dispatch(fetchMessages(query, 1, tag === "Tags" ? false : tag));
  };

  const getPreferences = () => {
    dispatch(fetchPreferences());
  };

  const getUnReadBadge = (item) => {
    const { unread_count_data } = messages;
    let currentCount = unread_count_data.filter(
      (val) => val.phone_no == item.phone_no
    );
    return (
      <>
        {currentCount.length ? (
          <span className="messages-count"> {currentCount[0].count}</span>
        ) : (
          ""
        )}
      </>
    );
  };

  const fetchContactsData = () => {
    dispatch(fetchContacts());
  };

  const resetImage = () => {
    setLocalPhoto(false);
    setPhoto(false);
  };

  useEffect(() => {
    if (!messages.chat_phone_no) return;
    dispatch(fetchConversationAiStatus(messages.chat_phone_no));
  }, [messages.chat_phone_no, dispatch]);

  useEffect(() => {
    fetchContactsData();

    getPreferences();
    fetchMessagesData();
    handleInitialReadStatus(messages.data[0]);

    getCustomMessages();
    getTags();
  }, []);

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const onPicInputChange = (e) => {
    let localPhoto = URL.createObjectURL(e.target.files[0]);
    let photo = e.target.files[0];
    setPhoto(photo);
    setLocalPhoto(localPhoto);
    //this.setState({localPhoto, photo});
  };

  const handleKeyDown = (e) => {
    if (e.altKey && e.key === "Enter") {
      e.preventDefault();
      const textarea = e.target;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const oldValue = textarea.value;
      textarea.value =
        oldValue.substring(0, start) + "\n" + oldValue.substring(end);
      textarea.selectionStart = textarea.selectionEnd = start + 1;
      setNewMessage(textarea.value);
    } else if (e.key === "Enter") {
      e.preventDefault();
      handleSendMessage();
    }
  };

  function getStatusIcon(str) {
    let icon = "iconsminds-loading-3";
    switch (str) {
      case "new":
        icon = "iconsminds-loading-3";
        break;
      case "undelivered":
      case "failed":
      case "error":
        icon = "simple-icon-close";
        break;
      case "sent":
      case "delivered":
        icon = "simple-icon-check";
        break;
      default:
        icon = "iconsminds-loading-3";
    }

    return (
      <>
        <i
          style={{ marginRight: "0.8em", fontSize: "1.1em" }}
          className={icon}
        />
      </>
    );
  }
  useEffect(() => {
    const scrollableDiv = document.getElementById("messageContainer");
    const handleScroll = () => {
      const scrollTop = scrollableDiv.scrollTop;
      const clientHeight = scrollableDiv.clientHeight;
      const scrollHeight = scrollableDiv.scrollHeight;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

      if (isAtBottom) {
        setShowChatDownArrow(false);
      } else {
        setShowChatDownArrow(true);
      }
    };
    if (scrollableDiv) {
      scrollableDiv.addEventListener("scroll", handleScroll);
      return () => {
        scrollableDiv.removeEventListener("scroll", handleScroll);
      };
    }
  }, [messages?.chat_isLoading]);
  const scrollToBottom = () => {
    const scrollableDiv = document.getElementById("messageContainer");
    if (!scrollableDiv) {
      return;
    }
    scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
  };
  useEffect(() => {
    const scrollableDiv = document.getElementById("messageContainer");
    if (!scrollableDiv) {
      return;
    }
    scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
  }, [messages?.chat_isLoading]);

  const handleSingleMessage = () => {
    $("#messageList").css("display", "none");
    $("#messageContainer").css("display", "block");
  };

  const handleBackBtn = () => {
    $("#messageList").css("display", "block");
    $("#messageContainer").css("display", "none");
  };

  const handleChangeQuery = (e) => {
    setQuery(e.target.value);
    if (e.target.value == "") {
      setQuery("");
      dispatch(
        fetchMessages("", 1, selectedTag.tag === "Tags" ? false : selectedTag)
      );
    }
  };

  const onYReachEndConversation = () => {
    //let { searchKeyword, messages } = this.props
    if (!messages.isLoading && !messages.isMoreLoading) {
      dispatch(fetchMoreMessages(query));
    }
  };

  return (
    <>
      <div className="row mt-4">
        <div
          id="messageList"
          className="col-md-4 col-lg-4 col-sm-12 col-xs-12 main-section-scroll-height pt-1"
        >
          <div className="input-group tags mb-3">
            <input
              type="text"
              value={query}
              onChange={handleChangeQuery}
              onKeyDown={handleQuerySubmit}
              className="form-control"
              placeholder="&#xF002;  Search here..."
              style={{ fontFamily: "Arial, FontAwesome" }}
              aria-label="Text input with dropdown button"
            />
            <button
              className="btn btn-outline-secondary dropdown-toggle"
              type="button"
              style={{ backgroundColor: "#5C5BE3" }}
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {selectedTag.tag}
            </button>
            <ul
              className="dropdown-menu dropdown-menu-end"
              style={{ maxHeight: "300px", overflowY: "scroll" }}
            >
              {tags &&
                tags.data &&
                tags.data.map((tag) => (
                  <li key={tag.id} onClick={() => handleToggleTag(tag)}>
                    <a className="dropdown-item" href="#">
                      {tag.tag}
                    </a>
                  </li>
                ))}

              {/* <li>
                                    <hr className="dropdown-divider"/>
                                </li>
                                <li><a className="dropdown-item" href="#">Separated link</a></li>*/}
            </ul>
          </div>
          <div className="mt-4 d-flex justify-content-between align-items-center">
            <div className="">
              <div className="dropdown">
                <button
                  className="primary-btn-transparent dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  New Message
                </button>

                <ul className="dropdown-menu dropdown-menu-end">
                  <li onClick={() => handleMessageModal("individual")}>
                    <a className="dropdown-item" href="#">
                      Individual
                    </a>
                  </li>

                  <li onClick={() => handleMessageModal("group")}>
                    <a className="dropdown-item" href="#">
                      Group
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="d-flex align-items-center">
              <button
                className="primary-btn-transparent  dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Filter
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                <li onClick={() => setFilter("All")}>
                  <a
                    className={`dropdown-item ${filter == "All" && "active"}`}
                    href="#"
                  >
                    All
                  </a>
                </li>
                <li onClick={() => setFilter("Unread")}>
                  <a
                    className={`dropdown-item ${
                      filter == "Unread" && "active"
                    }`}
                    href="#"
                  >
                    Unread
                  </a>
                </li>
                <li onClick={() => setFilter("1+ response")}>
                  <a
                    className={`dropdown-item ${
                      filter == "1+ response" && "active"
                    }`}
                    href="#"
                  >
                    1+ response
                  </a>
                </li>
                <li onClick={() => setFilter("3+ response")}>
                  <a
                    className={`dropdown-item ${
                      filter == "3+ response" && "active"
                    }`}
                    href="#"
                  >
                    3+ response
                  </a>
                </li>
                <li onClick={() => setFilter("5+ response")}>
                  <a
                    className={`dropdown-item ${
                      filter == "5+ response" && "active"
                    }`}
                    href="#"
                  >
                    5+ response
                  </a>
                </li>
                <li onClick={() => setFilter("10+ response")}>
                  <a
                    className={`dropdown-item ${
                      filter == "10+ response" && "active"
                    }`}
                    href="#"
                  >
                    10+ response
                  </a>
                </li>
              </ul>
              {!isSelectEnable ? (
                <button
                  className="primary-btn ms-2"
                  onClick={() => setIsSelectEnable(true)}
                >
                  Select
                </button>
              ) : (
                <>
                  <button
                    className="primary-btn ms-2 dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Action{" "}
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li onClick={selectedChats.length > 0 && bulkDelete}>
                      <a className="dropdown-item" href="#">
                        Delete
                      </a>
                    </li>
                    <li onClick={() => setIsSelectEnable(false)}>
                      <a className="dropdown-item" href="#">
                        Cancel
                      </a>
                    </li>
                  </ul>
                </>
              )}
            </div>
          </div>
          <ScrollBar
            options={{ suppressScrollX: true, wheelPropagation: false }}
            onYReachEnd={onYReachEndConversation}
          >
            <div className="mt-4">
              {messages.data.length > 0 ? (
                messages.data.map((message, index) => {
                  let local_date = moment
                    .utc(message?.created_at?.replace(/-/g, "/"))
                    .local()
                    .format("MMM DD, hh:mm A");
                  return (
                    getConversationVisibility(message) &&
                    (!messages.isLoading ? (
                      <div
                        key={message.id}
                        style={{ cursor: "pointer" }}
                        className={`single-message ${
                          message?.phone_no == messages.chat_phone_no &&
                          "active"
                        }`}
                      >
                        <div
                          className="d-flex"
                          onClick={(e) => {
                            if (e.target.tagName.toLowerCase() === "input")
                              return;
                            if (windowSize.current[0] <= 600)
                              handleSingleMessage();
                            handleActiveChat(message);
                          }}
                        >
                          <div className="pt-2">
                            {isSelectEnable && (
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  onChange={(e) => toggleCheckbox(e, message)}
                                  value=""
                                  id="flexCheckDefault"
                                />
                              </div>
                            )}
                          </div>
                          <div className="">
                            <Avatar
                              size={
                                userSelectedFont === "small"
                                  ? 28
                                  : userSelectedFont === "medium"
                                  ? 30
                                  : userSelectedFont === "large"
                                  ? 35
                                  : 35
                              }
                              name={
                                message.full_name ? message.full_name : "U k"
                              }
                              round
                            />

                            {/*<img width="40" src={userIcon} className="img-fluid"/>*/}
                          </div>
                          <div className="ps-2 d-flex flex-column">
                            <Box
                              fontSize={
                                userSelectedFont === "small"
                                  ? "14px"
                                  : userSelectedFont === "medium"
                                  ? "16px"
                                  : userSelectedFont === "large"
                                  ? "18px"
                                  : "18px"
                              }
                              className="user-name"
                            >
                              {message.full_name
                                ? message.full_name
                                : encodePhoneNumber(message.sender_phone)}
                            </Box>
                            <Box
                              fontSize={
                                userSelectedFont === "small"
                                  ? "11px"
                                  : userSelectedFont === "medium"
                                  ? "13px"
                                  : userSelectedFont === "large"
                                  ? "16px"
                                  : "16px"
                              }
                              className="date mt-2"
                            >
                              {local_date}
                            </Box>
                            <Box
                              fontSize={
                                userSelectedFont === "small"
                                  ? "11px"
                                  : userSelectedFont === "medium"
                                  ? "13px"
                                  : userSelectedFont === "large"
                                  ? "16px"
                                  : "16px"
                              }
                              className="message mt-2"
                            >
                              {message.message && message.message.length > 20
                                ? message.message.slice(0, 20) + "..."
                                : message.message}
                            </Box>
                          </div>
                          <div
                            className="d-flex align-items-center position-absolute controls-position"
                            data-bs-toggle="modal"
                            data-bs-target={`${
                              preferences.show_delete ? "#delteContact" : ""
                            }`}
                            onClick={() =>
                              preferences.show_delete ? "" : handleDelete()
                            }
                          >
                            {/* <img src={usersIcon} className="img-fluid"/>*/}
                            {getUnReadBadge(message)}
                            <Image
                              boxSize={
                                userSelectedFont === "small"
                                  ? "24px"
                                  : userSelectedFont === "medium"
                                  ? "26px"
                                  : userSelectedFont === "large"
                                  ? "30px"
                                  : "30px"
                              }
                              // width="30"
                              src={deleteIcon}
                              className="ms-2 img-fluid"
                            />
                          </div>
                        </div>
                        <div className="mt-2">
                          {/* {preferences.show_notes ? <input type="text" placeholder="Enter Notes:" value={message.note} onChange={(e) => { dispatch(updateNotesMessage(e.target, message)) }} onBlur={(e) => dispatch(onChangeNotes(e.target, message, "messages"))} className="form-control message" /> : ''} */}
                          {preferences.show_notes ? (
                            <textarea
                              rows={1}
                              placeholder="Enter Notes:"
                              value={message.note}
                              onChange={(e) => {
                                dispatch(updateNotesMessage(e.target, message));
                              }}
                              onBlur={(e) =>
                                dispatch(
                                  onChangeNotes(e.target, message, "messages")
                                )
                              }
                              className="form-control message textareaexpand"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                        <div ref={messagesEndRef} />
                      </div>
                    ) : (
                      <div className="loadingMessagesList" />
                    ))
                  );
                })
              ) : (
                <Box
                  as={"p"}
                  fontSize={
                    userSelectedFont === "small"
                      ? "11px"
                      : userSelectedFont === "medium"
                      ? "13px"
                      : userSelectedFont === "large"
                      ? "16px"
                      : "16px"
                  }
                  style={{ marginTop: "40px", textAlign: "center" }}
                >
                  No Messages.
                </Box>
              )}
            </div>
          </ScrollBar>

          {!messages.isLoading && messages.isMoreLoading && (
            <div className="isMoreLoading" />
          )}
        </div>

        {!messages?.chat_isLoading ? (
          <div
            style={{
              position: "relative",
            }}
            id="messageContainer"
            className="message-container-scroll-height col-md-8 col-lg-8 col-sm-12 col-xs-12 desktop-display"
          >
            <div
              style={{
                height: "inherit",
              }}
              className="message-container   d-flex flex-column justify-content-between"
            >
              <div className="relative ">
                <div
                  style={{
                    position: "sticky",
                    height: "70px",
                    width: "100%",
                    right: "0",
                    top: "0",
                  }}
                  className="details d-flex justify-content-between align-items-center "
                >
                  <div className="w-full d-flex align-items-center">
                    <i
                      onClick={handleBackBtn}
                      id="backBtn"
                      className="fa-solid fa-chevron-left me-2 mobile-display"
                    ></i>
                    {/*<img src={userIcon}/>*/}
                    <Avatar
                      size={
                        userSelectedFont === "small"
                          ? 28
                          : userSelectedFont === "medium"
                          ? 30
                          : userSelectedFont === "large"
                          ? 35
                          : 35
                      }
                      name={
                        messages.chat_data.length > 0 &&
                        messages.chat_data[0].full_name
                          ? messages.chat_data[0].full_name
                          : "U k"
                      }
                      round
                    />
                    <Box
                      fontSize={
                        userSelectedFont === "small"
                          ? "14px"
                          : userSelectedFont === "medium"
                          ? "16px"
                          : userSelectedFont === "large"
                          ? "18px"
                          : "18px"
                      }
                      className="user-name ms-2"
                    >
                      {messages.chat_data.length > 0 &&
                      messages.chat_data[0].full_name
                        ? messages.chat_data[0].full_name
                        : ""}
                    </Box>
                    <button
                      style={{
                        fontSize:
                          userSelectedFont === "small"
                            ? "14px"
                            : userSelectedFont === "medium"
                            ? "16px"
                            : userSelectedFont === "large"
                            ? "18px"
                            : "18px",
                      }}
                      className="contact-btn ms-2 desktop-display"
                    >
                      {messages.chat_data.length > 0 &&
                      messages.chat_data[0].sender_phone
                        ? encodePhoneNumber(messages.chat_data[0].sender_phone)
                        : ""}
                    </button>
                  </div>

                  <div className="d-flex">
                    {/*<button className="primary-btn-transparent">Admin <i
                                                className="fa-solid fa-ellipsis-vertical ms-2"></i></button>*/}
                    <button
                      className="primary-btn ms-2"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Action{" "}
                      <i className="fa-solid fa-ellipsis-vertical ms-2"></i>
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end">
                      <li
                        onClick={(e) => e.stopPropagation()}
                        className="dropdown-item d-flex justify-content-between align-items-center"
                      >
                        <span style={{ fontSize: "14px" }}>AI Auto Reply</span>

                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ width: "40px" }}
                        >
                          {messages.conversation_ai_loading ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                            />
                          ) : (
                            <Switch
                              size="sm"
                              isChecked={messages.conversation_ai_enabled}
                              isDisabled={messages.conversation_ai_loading}
                              onClick={(e) => e.stopPropagation()}
                              onChange={(e) =>
                                dispatch(
                                  updateConversationAiStatus(
                                    messages.chat_phone_no,
                                    e.target.checked
                                  )
                                )
                              }
                            />
                          )}
                        </div>
                      </li>

                      <li>
                        <hr className="dropdown-divider" />
                      </li>

                      <li onClick={handleDelete}>
                        <a className="dropdown-item">Delete</a>
                      </li>
                      <li onClick={handleUnread}>
                        <a className="dropdown-item">Unread</a>
                      </li>
                      {messages.chat_data.length > 0 &&
                        !messages.chat_data[0].full_name && (
                          <li>
                            <a
                              className="dropdown-item"
                              data-bs-toggle="offcanvas"
                              data-bs-target="#createContactCanvas"
                              aria-controls="createContactCanvas"
                            >
                              {" "}
                              Add To Contacts{" "}
                            </a>
                          </li>
                        )}
                    </ul>
                  </div>
                </div>
                <div style={{ marginTop: "80px" }} className="ps-3 pe-3 pb-5 ">
                  <div style={{ position: "relative" }} className="">
                    {messages &&
                      messages.chat_data &&
                      messages.chat_data.length > 0 &&
                      messages.chat_data.map((chat) => {
                        let local_date = moment
                          .utc(
                            chat.created_at &&
                              chat.created_at.replace(/-/g, "/")
                          )
                          .local()
                          .format("MMM DD, hh:mm A");

                        return (
                          <>
                            {chat.receive_or_sent === "receive" ? (
                              <div key={chat.id} className="user-message self">
                                {/* <div className="name">{chat.full_name?chat.full_name:chat.sender_phone}</div>*/}
                                {chat.file ? (
                                  chat.file.match(/\.(jpeg|jpg|gif|png)$/) !=
                                    null || chat.file.match(/blob:/g) ? (
                                    <img
                                      alt={chat.message}
                                      src={chat.file}
                                      onClick={() => {
                                        window.open(chat.file);
                                      }}
                                      height={200}
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "contain",
                                      }}
                                      className=""
                                    />
                                  ) : (
                                    <a href={chat.file}>Attachment</a>
                                  )
                                ) : (
                                  <></>
                                )}

                                <Box
                                  fontSize={
                                    userSelectedFont === "small"
                                      ? "14px"
                                      : userSelectedFont === "medium"
                                      ? "16px"
                                      : userSelectedFont === "large"
                                      ? "18px"
                                      : "18px"
                                  }
                                  style={{ whiteSpace: "pre-line" }}
                                  className="text"
                                >
                                  {chat.message}
                                </Box>
                                <Box
                                  fontSize={
                                    userSelectedFont === "small"
                                      ? "10px"
                                      : userSelectedFont === "medium"
                                      ? "12px"
                                      : userSelectedFont === "large"
                                      ? "14px"
                                      : "14px"
                                  }
                                  className="time"
                                >
                                  {local_date}
                                </Box>
                              </div>
                            ) : (
                              <div className="user-message other">
                                {/* <div className="name">{chat.responsible_name}</div>*/}
                                {chat.file ? (
                                  chat.file.match(/\.(jpeg|jpg|gif|png)$/) !=
                                    null || chat.file.match(/blob:/g) ? (
                                    <img
                                      alt={chat.message}
                                      src={chat.file}
                                      onClick={() => {
                                        window.open(chat.file);
                                      }}
                                      height={200}
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "contain",
                                      }}
                                      className=""
                                    />
                                  ) : (
                                    <a href={chat.file}>Attachment</a>
                                  )
                                ) : (
                                  <></>
                                )}
                                <Box
                                  fontSize={
                                    userSelectedFont === "small"
                                      ? "14px"
                                      : userSelectedFont === "medium"
                                      ? "16px"
                                      : userSelectedFont === "large"
                                      ? "18px"
                                      : "18px"
                                  }
                                  style={{ whiteSpace: "pre-line" }}
                                  className="text"
                                >
                                  {chat.message}
                                </Box>
                                <Box
                                  fontSize={
                                    userSelectedFont === "small"
                                      ? "10px"
                                      : userSelectedFont === "medium"
                                      ? "12px"
                                      : userSelectedFont === "large"
                                      ? "14px"
                                      : "14px"
                                  }
                                  className="time"
                                >
                                  {getStatusIcon(chat.status)}
                                  {/*<i className="fa-regular fa-clock me-1"></i>*/}
                                  {local_date}
                                </Box>
                              </div>
                            )}
                          </>
                        );
                      })}

                    {/* <div ref={messagesEndRef} /> */}
                    {showChatDownArrow && (
                      <div
                        onClick={scrollToBottom}
                        style={{
                          position: "fixed",
                          // marginBottom: "150px",
                          bottom: "150px",
                          border: "1px solid white",
                          borderRadius: "100%",
                          padding: "5px 8px",
                          backgroundColor: "#576CD1",
                          alignItems: "end",
                          color: "white",
                          right: "70px",
                          zIndex: "50",
                        }}
                      >
                        <ChevronDownIcon size={32} />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div
                style={{
                  position: "sticky",
                  height: "70px",
                  width: "100%",
                  alignItems: "end",
                }}
                className="details d-flex border-top"
              >
                <div className="">
                  <button
                    className="primary-btn dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Template
                  </button>
                  <ul
                    className="dropdown-menu dropdown-menu-end"
                    style={{ maxHeight: "300px", overflowY: "scroll" }}
                  >
                    {customMessages &&
                      customMessages.templates &&
                      customMessages.templates.map((template) => (
                        <li
                          key={template.id}
                          onClick={() => {
                            dispatch(setChatMessage(template.text_message));
                            setNewMessage(template.text_message);
                          }}
                        >
                          <a className="dropdown-item" href="#">
                            {template.name}
                          </a>
                        </li>
                      ))}
                  </ul>
                </div>
                <div className="position-relative w-100 ps-2">
                  <div className="d-flex align-items-end send">
                    {localPhoto && (
                      <div
                        className="d-flex flex-column align-items-center"
                        style={{ margin: 10, textAlign: "center" }}
                      >
                        <img
                          alt="upload image"
                          className="img-thumbnail border-0 align-self-center"
                          src={localPhoto}
                          width={120}
                          style={{ textAlign: "center" }}
                        />
                        {/* <div class=""> */}
                        <Button
                          outline
                          color="primary"
                          className="btn-xs mt-1 remove-btn"
                          onClick={resetImage}
                        >
                          Remove
                        </Button>
                        {/* </div> */}
                      </div>
                    )}
                    <textarea
                      style={{
                        maxHeight: "230px",
                        overflowY: "auto",
                      }}
                      type="text"
                      className="form-control border-1 input-textarea "
                      placeholder="Type your message here"
                      onKeyDown={handleKeyDown}
                      ref={textAreaRef}
                      rows={1}
                      onClick={handleInputClick}
                      aria-label="Text input with dropdown button"
                      value={newMessage}
                      onChange={(e) => {
                        dispatch(setChatMessage(e.target.value));
                        setNewMessage(e.target.value);
                      }}
                    />
                    <input
                      name="photo"
                      onChange={(e) => onPicInputChange(e)}
                      accept="image/*"
                      type="file"
                      hidden
                      ref={hiddenFileInput}
                    />
                    <button
                      className="primary-btn"
                      style={{
                        width: "35px",
                        fontSize: "15px",
                        background: "transparent",
                        padding: "0px",
                        color: "black",
                        marginRight: "8px",
                        marginBottom: "10px",
                      }}
                      onClick={handleClick}
                    >
                      <i class="simple-icon-paper-clip"></i>
                    </button>
                    <button
                      className="primary-btn d-flex"
                      onClick={handleSendMessage}
                    >
                      Send <i className="fa-regular fa-paper-plane ms-1"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : messages.data.length > 0 ? (
          <div className="loadingMessageContainer" />
        ) : (
          <p>No Messages.</p>
        )}
      </div>
      <div
        className="modal fade"
        id="delteContact"
        tabIndex="-1"
        aria-labelledby="delteContactLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="delteContactLabel">
                Delete Record
              </h5>
              <button
                type="button"
                className="slider-close-btn"
                data-bs-dismiss="modal"
              >
                <img src={sliderCloseIcon} className="img-fluid" />
              </button>
            </div>
            <div className="modal-body">
              <div className="d-flex justify-content-center">
                <img src={deletePopupIcon} />
              </div>
              <div className="mt-4">
                <p className="text-center">
                  Do you really want to remove this record?{" "}
                </p>
              </div>
            </div>
            <div className="d-flex justify-content-center mb-4">
              <button
                className="slider-cancel-btn me-2"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                className="slider-success-btn"
                data-bs-dismiss="modal"
                onClick={handleDelete}
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      </div>
      <NewMessageModal
        isVisible={isVisible}
        toggle={handleMessageModal}
        contacts={contacts}
        type={messageType}
        tags={tags}
      />
      <CreateContactSlider phone={messages.chat_phone_no} />
    </>
  );
}

export default Messages;
